export default "__VITE_ASSET__2oB37M7a__"